/**
 *  Home New Fasshion Page
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import BrandLogoSlider from '../../widgets/BrandLogoSlider.js';
import DealOfTheWeek2 from '../../widgets/home2/DealOfTheWeek2.js';
import HomeBanner2 from '../../widgets/home2/HomeBanner2.js';
import LatestBlogSlider from '../../widgets/home2/LatestBlogSlider.js';
import NewCollecation from '../../widgets/home2/NewCollecation.js';
import Subscribe2 from '../../widgets/home2/Subscribe2.js';
import HomeSlider from '../../widgets/HomSlider2.js';
import ProductSlider from '../../widgets/ProductSlider.js';

const saleslider = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows:true,
    slidesToShow: 4,
    slidesToScroll: 2,
     responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }
  ]
};





class HomePage2 extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
      }
    render() {
     return (
          <div>
                 <HomeSlider />
                 <div id="content" className="site-content" tabIndex={-1}>
                    <div className="content-wrapper content-wrapper-vc-enabled">
                        <div className="container-fluid">
                            <Row>
                                <Col sm={12} className="px-0">
                                <div id="primary" className="content-area">
                                    <main id="main" className="site-main">
                                        <article className="page type-page status-publish hentry">
                                            <div className="container">
                                                <HomeBanner2 />
                                            </div>
                                            <div className="countdown-main" style={{ backgroundImage: 'url(' + require(`../../assets/images/categories/new-fashion/offer-deal-bg.jpg`) + ')' }}  >
                                                <Container>
                                                        <DealOfTheWeek2 />
                                                </Container>
                                            </div>
                                            <div className="newsletter-section section-ptb" style={{ backgroundImage: 'url(' + require(`../../assets/images/categories/new-fashion/new-letter-bg.jpg`) + ')' }} >
                                                <Container>
                                                        <Subscribe2 />
                                                </Container>
                                            </div>
                                    
                                             <Container>
                                                <Row>
                                                    <BrandLogoSlider />
                                                </Row>
                                            </Container>
                                        </article>
                                    </main>
                                </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
          </div>
     )
    }
}
export default HomePage2;
